// src/utils/authInterceptor.js
// Attaches `Authorization: Bearer <idToken>` to every m115-freshcard request,
// so none of the 100+ call sites need editing.
//
// Register ONCE at startup, before any m115 call can run, e.g. in src/index.js:
//   import './utils/authInterceptor';

import axios from 'axios';
import firebase from '../store/firebase';

// Step 1 scope: m115 only. Widen later (e.g. to any FB_URL function) as a separate change.
const NEEDS_TOKEN = (url = '') => url.includes('m115-freshcard');

// On a cold start, currentUser is null until the persisted session is restored.
// Wait for the first auth-state callback instead of sending a tokenless request.
// Resolves with null for genuinely signed-out users, so it never hangs.
let authReady = null;
function currentUser() {
  if (firebase.auth.currentUser) return Promise.resolve(firebase.auth.currentUser);
  if (!authReady) {
    authReady = new Promise((resolve) => {
      const unsubscribe = firebase.auth.onAuthStateChanged((u) => {
        unsubscribe();
        resolve(u);
      });
    });
  }
  return authReady.then(() => firebase.auth.currentUser);
}

axios.interceptors.request.use(async (config) => {
  if (!NEEDS_TOKEN(config.url)) return config;
  try {
    const user = await currentUser();
    if (user) {
      // getIdToken() returns a cached token and refreshes it only near expiry,
      // so this adds no network call to most requests.
      const token = await user.getIdToken();
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) {
    // Never block the request from here; the server logs (or later rejects) tokenless calls.
    console.warn('authInterceptor: could not attach ID token', e);
  }
  return config;
});